/* Oneso Shop Video — shared parts: brand look, wishlist heart, product panel (same as the Oneso Live Studio player). */
(function () {
'use strict';
if (window.BSVL) return;
var d = document, base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var TKNS = 'https://bayeas-agora-token.james-43d.workers.dev/';
function mk(tag, cls, text) { var n = d.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
function btn(cls, text, label, fn) { var b = mk('button', cls, text); b.type = 'button'; if (label) b.setAttribute('aria-label', label); b.addEventListener('click', function (e) { e.stopPropagation(); fn(e); }); return b; }
function stop(e) { e.stopPropagation(); }
function norm(src) { return String(src || '').replace(/^https?:/, '').split('?')[0]; }
function sized(src, w) { src = String(src || ''); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function money(x) {
var n = parseFloat(x); if (isNaN(n)) return '';
var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); } catch (e) { return '$' + n.toFixed(2); }
}
function loggedIn() {
try { return !!((window.__st && window.__st.cid) || (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId)); } catch (e) { return false; }
}
function loginUrl() { return base + 'account/login?return_to=' + encodeURIComponent(location.pathname + location.search); }
var ICON = {
on: 'M11 5 6 9H2v6h4l5 4V5z M15.5 8.5a5 5 0 0 1 0 7 M18.5 5.5a9 9 0 0 1 0 13',
off: 'M11 5 6 9H2v6h4l5 4V5z M22 9l-6 6 M16 9l6 6',
heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21.2l7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z',
share: 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8 M16 6l-4-4-4 4 M12 2v13',
close: 'M18 6 6 18 M6 6l12 12', play: 'M7 4v16l13-8z', pause: 'M8 5v14 M16 5v14',
prev: 'M15 18l-6-6 6-6', next: 'M9 18l6-6-6-6',
mini: 'M4 14h6v6 M20 10h-6V4 M14 10l7-7 M3 21l7-7', big: 'M15 3h6v6 M9 21H3v-6 M21 3l-7 7 M3 21l7-7'
};
function setIcon(b, path) {
var NS = 'http://www.w3.org/2000/svg', s = d.createElementNS(NS, 'svg'), pa = d.createElementNS(NS, 'path');
[['viewBox', '0 0 24 24'], ['width', '20'], ['height', '20'], ['fill', 'none'], ['stroke', 'currentColor'], ['stroke-width', '2'], ['stroke-linecap', 'round'], ['stroke-linejoin', 'round'], ['aria-hidden', 'true']].forEach(function (a) { s.setAttribute(a[0], a[1]); });
pa.setAttribute('d', path); s.appendChild(pa); b.textContent = ''; b.appendChild(s);
}
function ibtn(path, label, fn) { var b = btn('bsv-ib', '', label, fn); setIcon(b, path); return b; }
function brand() {
var p;
try { var c0 = JSON.parse(sessionStorage.getItem('bayeas-exp') || 'null'); if (c0 && Date.now() - c0.t < 600000) p = Promise.resolve(c0.j || {}); } catch (e) {}
if (!p) p = fetch(TKNS + '?kind=exp', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : {}; })
.then(function (j) { try { sessionStorage.setItem('bayeas-exp', JSON.stringify({ t: Date.now(), j: j })); } catch (e) {} return j || {}; }).catch(function () { return {}; });
p.then(function (j) {
var st = d.documentElement.style, hex = function (x) { return /^#[0-9a-fA-F]{6}$/.test(String(x || '')) ? x : ''; }, c = hex(j.color);
if (c) { var n = parseInt(c.slice(1), 16), lum = (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255; st.setProperty('--bl-brand', c); st.setProperty('--bl-ink', lum > 0.6 ? '#111111' : '#ffffff'); }
if (hex(j.accent)) st.setProperty('--bl-accent', j.accent);
var f = { 'Inter': 'Inter', 'Poppins': 'Poppins', 'DM Sans': 'DM+Sans', 'Montserrat': 'Montserrat' }[j.font];
if (f) { st.setProperty('--bl-font', "'" + j.font + "', system-ui, sans-serif"); if (!d.getElementById('bl-font')) { var l = mk('link'); l.id = 'bl-font'; l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=' + f + ':wght@400;600;700;800;900&display=swap'; d.head.appendChild(l); } }
});
}
var pdpCache = {};
function pdp(handle) {
if (!handle) return Promise.resolve({ msrp: null, sn: '' });
if (!pdpCache[handle]) {
pdpCache[handle] = fetch(base + 'products/' + handle, { headers: { Accept: 'text/html' } }).then(function (r) { return r.ok ? r.text() : ''; })
.then(function (html) {
var m = /MSRP\s*:?\s*(?:<[^>]+>\s*)*\$?\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)/i.exec(html), n = m ? parseFloat(m[1].replace(/,/g, '')) : NaN, sn = '';
try {
var doc = new DOMParser().parseFromString(html, 'text/html'), el = doc.querySelector('product-info p.product__text.subtitle, p.product__text.subtitle');
sn = el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '';
if (!sn) { var m2 = /STYLE\s*(?:NUMBER|#|NO\.?)\s*:?\s*(?:<[^>]+>\s*)*([A-Za-z0-9][A-Za-z0-9._\/-]{1,39})/i.exec(html); sn = m2 ? m2[1] : ''; }
} catch (e) {}
return { msrp: n > 0 ? n : null, sn: /^[A-Za-z0-9][A-Za-z0-9 ._\/-]{0,39}$/.test(sn) ? sn : '' };
}).catch(function () { return { msrp: null, sn: '' }; });
}
return pdpCache[handle];
}
function priceParts(price, m) { var out = []; if (loggedIn() && price !== '' && price != null && !isNaN(parseFloat(price))) out.push(['WHOLESALE', money(price)]); if (m) out.push(['MSRP', money(m)]); return out; }
function priceRow(cls, parts) { var el = mk('div', cls); parts.forEach(function (p) { var sp = mk('span'); sp.appendChild(mk('b', null, p[0] + ': ')); sp.appendChild(d.createTextNode(p[1])); el.appendChild(sp); }); return el; }
var swishP = null;
function swish() {
if (!swishP) {
swishP = import(location.origin + base + 'apps/wishlist/assets/swish.js')
.then(function (m) { return m.swishApp({ proxy: { baseUrl: base + 'apps/wishlist' } }); })
.then(function (s) { return s && s.api && s.api.items ? s : null; }).catch(function () { return null; })
.then(function (s) { if (s) return s; var g = window.swish || window.Swish; return g && g.api && g.api.items ? g : null; });
}
return swishP;
}
function tailId(x) { var m = /(\d+)$/.exec(String(x == null ? '' : x)); return m ? m[1] : ''; }
function wishFind(s, pid) {
return s.api.items.list({ query: 'product:' + pid }).then(function (r) {
var dd = r && r.data, arr = Array.isArray(dd) ? dd : (dd && (dd.items || dd.data || dd.nodes)) || [];
var hit = arr.filter(function (it) { return it && (it.productId == null || tailId(it.productId) === String(pid)); })[0];
return hit ? hit.id : null;
});
}
function wkApp() { var W = window.WishlistKing; return W && typeof W.addWishlistItem === 'function' && typeof W.removeWishlistItem === 'function' ? W : null; }
function whenWk(ms) { return new Promise(function (res) { var t0 = Date.now(); (function poll() { var W = wkApp(); if (W || Date.now() - t0 > ms) res(W); else setTimeout(poll, 200); })(); }); }
function heart(flash) {
var x = null, itemId = null, busy = false, info = null, live = false, b = ibtn(ICON.heart, 'Save to wishlist', toggle);
b.style.display = 'none';
function paint() { b.setAttribute('aria-pressed', String(!!itemId)); b.setAttribute('aria-label', itemId ? 'Remove from wishlist' : 'Save to wishlist'); b.className = 'bsv-ib' + (itemId ? ' bsv-on' : ''); }
function vid() { return x.variants && x.variants[0] && x.variants[0].id ? Number(x.variants[0].id) : undefined; }
function seed() { return { productId: Number(x.id), productHandle: x.handle, variantId: vid() }; }
/* The wishlist app (Wishlist King) can finish loading after the player opens (a shared Shop Video link opens the player
   while the page is still loading), so the heart waits for it (up to 10 seconds) before trying the other way. */
function bind(prod) {
x = prod; if (!x || !x.id) return;
whenWk(10000).then(function (W) {
if (x !== prod) return;
if (W) {
b.style.display = ''; paint();
try { var stt = W._state || W.state, ob = stt && stt.observeProductInfo && stt.observeProductInfo(seed()); if (ob && ob.subscribe) ob.subscribe(function (pi) { if (!pi || typeof pi !== 'object') return; info = pi; live = true; itemId = pi.inWishlist ? (pi.wishlistItemId || true) : null; paint(); }); } catch (err) {}
return;
}
swish().then(function (s) { if (!s) return; b.style.display = ''; return wishFind(s, x.id).then(function (id) { itemId = id; paint(); }); }).catch(function () {});
});
}
function viaWk(W) {
var target = info || seed(), removing = !!itemId;
if (removing && !info && itemId !== true) target.wishlistItemId = itemId;
return Promise.resolve(removing ? W.removeWishlistItem(target) : W.addWishlistItem(target)).then(function (r) {
if (r && r.error) throw r.error;
if (!live) itemId = removing ? null : ((r && (r.wishlistItemId || r.id)) || true);
flash(removing ? 'Removed from wishlist' : 'Saved to wishlist');
});
}
function viaSwish() {
return swish().then(function (s) {
if (!s) throw 0;
if (itemId) {
return Promise.resolve(itemId === true ? wishFind(s, x.id) : itemId).then(function (id) {
if (!id) { itemId = null; return; }
return s.api.items.deleteById(id).then(function (r) { if (r && r.error) throw r.error; itemId = null; flash('Removed from wishlist'); });
});
}
var body = { productId: Number(x.id), quantity: 1 }; if (vid()) body.variantId = vid();
return s.api.items.create(body).then(function (r) { if (!r || r.error) throw (r && r.error) || 0; var dd = r.data || {}; itemId = dd.id || (dd.item && dd.item.id) || true; flash('Saved to wishlist'); });
});
}
function toggle() {
if (busy || !x) return;
if (!itemId && !loggedIn()) { flash('Log in to save to your wishlist'); return; }
busy = true;
var W = wkApp();
(W ? viaWk(W) : viaSwish()).catch(function () { flash('Could not update your wishlist'); }).then(function () { busy = false; paint(); });
}
return { el: b, bind: bind };
}
function skel(body, title, img) {
body.textContent = ''; body.setAttribute('aria-busy', 'true');
var g = mk('div', 'bsv-skg');
if (img) { var im = mk('img'); im.src = sized(img, 600); im.alt = ''; g.appendChild(im); } else g.appendChild(mk('i', 'bsv-sk'));
g.appendChild(mk('i', 'bsv-sk')); body.appendChild(g);
if (title) body.appendChild(mk('div', 'bsv-h', title));
[[14, 40], [34, 90], [34, 90], [34, 60]].forEach(function (x) { var l = mk('i', 'bsv-sk'); l.style.height = x[0] + 'px'; l.style.width = x[1] + '%'; l.style.margin = '12px 0'; body.appendChild(l); });
}
function reveal(body) {
body.removeAttribute('aria-busy'); body.classList.remove('bsv-fd'); void body.offsetWidth; body.classList.add('bsv-fd');
[].forEach.call(body.querySelectorAll('.bsv-g img'), function (im) { function ok() { im.classList.add('bsv-ok'); } if (im.complete && im.naturalWidth) ok(); else { im.addEventListener('load', ok); im.addEventListener('error', ok); } });
}
function isMobile() { try { return matchMedia('(max-width: 820px), (pointer: coarse) and (max-width: 1100px)').matches; } catch (e) { return false; } }
function toast(msg) { var t = d.getElementById('bsvToast'); if (!t) { t = mk('div', 'bsv-toast'); t.id = 'bsvToast'; t.setAttribute('role', 'status'); d.body.appendChild(t); } t.textContent = msg; t.classList.add('on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 2600); }
function shareUrl(handles, label) { return location.origin + base + '?shop_video=' + encodeURIComponent(handles.join(',')) + '&sv_label=' + encodeURIComponent(label); }
function share(handles, label, say) {
if (window.BSVShare) return window.BSVShare(handles, label);
say = say || toast;
if (!handles || !handles.length) { say('Add styles first.'); return; }
var url = shareUrl(handles, label);
function copied() { say('Link copied'); }
function manual() { var ta = mk('textarea'); ta.value = url; ta.style.cssText = 'position:fixed;opacity:0'; d.body.appendChild(ta); ta.select(); try { d.execCommand('copy'); copied(); } catch (err) { window.prompt('Copy this Shop Video link:', url); } ta.remove(); }
if (navigator.share && isMobile()) { navigator.share({ title: 'Oneso Shop Video', text: 'Shop Video · ' + label, url: url }).catch(function () {}); return; }
if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(copied, manual); else manual();
}
function poolHandles() { var seen = {}, out = []; [].forEach.call(d.querySelectorAll('.bdv-pool .bdv-chip'), function (c) { var h = c.getAttribute('data-drag') || c.getAttribute('data-find') || ''; if (/^[a-z0-9-]+$/i.test(h) && !seen[h]) { seen[h] = 1; out.push(h); } }); return out; }
function secData(el) {
var all = el.closest('.bdv-allshare'); if (all) return { handles: poolHandles(), label: 'All Wish List Styles' };
var sec = el.closest('.bdv-sec'); if (!sec) return null;
return { handles: (sec.getAttribute('data-handles') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean), label: sec.getAttribute('data-label') || 'Delivery' };
}
function addBtns(acts, before, what) {
if (!acts || acts.querySelector('.bsv-shr')) return;
var s = mk('button', 'bsv-shr'); s.type = 'button'; s.title = 'Share the Shop Video link for ' + what; s.setAttribute('aria-label', s.title);
s.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M8 10.5V1.8"/><path d="M4.8 4.8L8 1.6l3.2 3.2"/><path d="M5 7H3.2v7.4h9.6V7H11"/></svg><span>Shop Video</span>';
acts.insertBefore(s, before || null);
}
var lastCtx = null;
d.addEventListener('click', function (e) { var t = e.target; if (!t.closest || t.closest('#bay-share-modal')) return; if (t.closest('.bdv-sec, .bdv-allshare')) lastCtx = secData(t); }, true);
function modalCtx(m) {
var h = (m.querySelector('h3') || {}).textContent || '', hit = null;
[].forEach.call(d.querySelectorAll('.bdv-sec[data-handles]'), function (sec) { var l = sec.getAttribute('data-label') || ''; if (!hit && l && h.indexOf(l) > -1) hit = secData(sec); });
if (!hit && /all/i.test(h)) hit = { handles: poolHandles(), label: 'All Wish List Styles' };
return hit || lastCtx;
}
function injectModal() {
var m = d.getElementById('bay-share-modal'), row = m && m.querySelector('.bsm-row'); if (!row) return;
if (/video line sheet/i.test((m.querySelector('h3') || {}).textContent || '')) { var old = row.querySelector('.bsv-shm'); if (old) old.remove(); return; }
if (m.getAttribute('data-bsv') || row.querySelector('.bsv-shm')) return;
var s = mk('button', 'bsv-shm'); s.type = 'button'; s.title = 'Copy or share the Shop Video link';
s.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.6" style="vertical-align:-2px;margin-right:5px"><path d="M8 10.5V1.8"/><path d="M4.8 4.8L8 1.6l3.2 3.2"/><path d="M5 7H3.2v7.4h9.6V7H11"/></svg>Shop Video';
s.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var x = modalCtx(m); var c = row.querySelector('.bsm-link'); if (c) c.click(); if (x) share(x.handles, x.label); });
row.insertBefore(s, row.querySelector('.bsm-link'));
}
function inject() {
injectModal();
[].forEach.call(d.querySelectorAll('.bdv-allshare-pdf span'), function (n) { if (/\(PDF\)/.test(n.textContent)) n.textContent = n.textContent.replace(/\s*\(PDF\)/, ''); });
[].forEach.call(d.querySelectorAll('.bdv-sec[data-handles]'), function (sec) { var acts = sec.querySelector('.bdv-acts'); addBtns(acts, acts && acts.querySelector('[data-act="pdf"]'), 'the styles in this delivery'); });
[].forEach.call(d.querySelectorAll('.bdv-pool .bdv-allshare'), function (row) { addBtns(row, null, 'all your wish list styles'); });
}
d.addEventListener('click', function (e) {
var b = e.target.closest && e.target.closest('.bsv-shr'); if (!b) return;
var x = secData(b); if (!x) return;
e.preventDefault(); e.stopPropagation();
share(x.handles, x.label);
}, true);
var q = false;
new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; inject(); }); }).observe(d.documentElement, { childList: true, subtree: true });
inject();
/* Cart: the cart button in every player (and "View cart" after adding) opens the SparkLayer cart over the player.
   SparkLayer finishes loading a few seconds after the page, longer on a phone on mobile data or when a shared Shop
   Video link opens the player straight away. A tap before it was ready used to send buyers to the store's own Shopify
   cart page instead. Now the Shopify cart page never opens from a player: the tap shows "Opening your cart…" and is
   repeated the moment SparkLayer is ready, so the player opens the SparkLayer cart itself (pausing the video and
   stepping under the cart as usual). */
var lastTap = null, lastTapT = 0, cartWait = null, nativeOpen = window.open;
d.addEventListener('click', function (e) { var t = e.target; if (!t || !t.closest || cartWait && cartWait.replaying) return; lastTap = t.closest('button, a, [role="button"]'); lastTapT = Date.now(); }, true);
function sparkReady() { var S = window.spark; return !!(S && typeof S.openDrawer === 'function'); }
function isCartPage(u) { try { var x = new URL(String(u), location.href); return x.origin === location.origin && /\/cart\/?$/.test(x.pathname) && !x.search; } catch (e) { return false; } }
function drawerOpen() { var sd = d.querySelector('spark-drawer'); return !!(sd && sd.shadowRoot && sd.shadowRoot.querySelector('[class*="z-99999"]')); }
/* open the SparkLayer cart with any player window that sits above it (z-index 99999 and up) dropped just under it until it closes */
function openOver() {
var lifted = [];
[].forEach.call(d.body.children, function (n) { if (/^SPARK-/.test(n.tagName)) return; var cs = getComputedStyle(n); if (cs.position === 'fixed' && (parseInt(cs.zIndex, 10) || 0) >= 99999) { lifted.push([n, n.style.zIndex]); n.style.zIndex = '99990'; } });
try { window.spark.openDrawer(); } catch (e) {}
if (!lifted.length) return;
var seen = false, t0 = Date.now(), t = setInterval(function () {
if (drawerOpen()) { seen = true; return; }
if (!seen && Date.now() - t0 < 5000) return;
clearInterval(t); lifted.forEach(function (x) { x[0].style.zIndex = x[1]; });
}, 250);
}
function sparkCart(from) {
if (sparkReady()) { openOver(); return; }
if (cartWait) { if (from) cartWait.el = from; return; }
toast('Opening your cart…');
var w = cartWait = { el: from || null, t0: Date.now() };
(function poll() {
if (cartWait !== w) return;
if (sparkReady()) {
if (w.el && w.el.isConnected) { w.replaying = true; try { w.el.click(); } catch (e) {} cartWait = null; var t1 = Date.now(), chk = setInterval(function () { if (drawerOpen()) clearInterval(chk); else if (Date.now() - t1 > 1500) { clearInterval(chk); openOver(); } }, 250); }
else { cartWait = null; openOver(); }
return;
}
if (Date.now() - w.t0 > 20000) { cartWait = null; toast('Your cart is still loading. Please try again in a moment.'); return; }
setTimeout(poll, 200);
})();
}
window.open = function (url) {
if (isCartPage(url)) { sparkCart(Date.now() - lastTapT < 1500 ? lastTap : null); return null; }
return nativeOpen.apply(window, arguments);
};
window.BSVL = { isMobile: isMobile, toast: toast, share: share, d: d, base: base, mk: mk, btn: btn, stop: stop, norm: norm, sized: sized, money: money, loggedIn: loggedIn, loginUrl: loginUrl, ICON: ICON, setIcon: setIcon, ibtn: ibtn, brand: brand, pdp: pdp, priceParts: priceParts, priceRow: priceRow, heart: heart, skel: skel, reveal: reveal, sparkCart: sparkCart };
})();